var observer = new MutationObserver(function (mutationsList, observer) {
  // Globales Objekt zum Speichern der aktuellen Optionen
  let gateConfig = {
    width: null,
    height: null,
    color: null,
    frame: null,
  };
  var element = document.querySelector(".konvajs-content");
  if (element) {
    console.log("Element found");
    //Temporären Layer entfernen
    var tempLayer = document.getElementById("tempLayer");
    // Ändern der Stileigenschaften
    tempLayer.style.height = "0px";
    tempLayer.style.width = "0px";
    tempLayer.display = "none";

    //BOFKonfigurator
    const container = document.querySelector(".konvajs-content");

    //const widthSelect = document.querySelector('.breite .sc-fifgeu');
    //console.log(widthSelect);
    //const heightSelect = document.querySelector('.height');
    //const frameSelect = document.querySelector('.frame');
    //const colorSelect = document.querySelector('.color');

    // Mapping der RAL-Farben zu HEX-Werten
    const ralToHex = {
      "RAL 9002": "#D7D7D7", // grauweiß
      "RAL 9006": "#A5A5A5", // weißaluminium
      "RAL 9016": "#F6F6F6", // verkehrsweiß
      "RAL 3000": "#A52019", // feuerrot
      "RAL 5010": "#0E294B", // enzianblau
      "RAL 6005": "#2D402C", // moosgrün
      "RAL 7016": "#1E232B", // anthrazitgrau
      "RAL 7021": "#1A1A1A", // schwarzgrau
      "RAL 8028": "#4E3B31", // terrabraun
      "RAL 9005": "#0A0A0A", // tiefschwarz
      "RAL 9007": "#8F8F8F", // graualuminium
      "RAL 9010": "#F2F2F2", // reinweiß
    };
    //Dynamische berechnung der Container größe
    //const containerWidth = container.clientWidth;
    //const containerHeight = container.clientHeight;
    function getAvailableDimensions() {
      // Dynamische Breite und Höhe des Containers ermitteln
      const containerWidth = container.clientWidth;
      const containerHeight = container.clientHeight;
      return { containerWidth, containerHeight };
    }
    const { containerWidth, containerHeight } = getAvailableDimensions();
    const stage = new Konva.Stage({
      container: container, // hier wird der Container mit der Klasse genutzt
      width: containerWidth,
      height: containerHeight,
    });
    //const scaleWidth = containerWidth / selectedWidth;
    //const scaleHeight = containerHeight / selectedHeight;

    // Wähle den kleineren Skalierungsfaktor, damit das Tor in beide Dimensionen passt
    //const scaleFactorb = Math.min(scaleWidth, scaleHeight);
    //console.log(scaleFactorb);
    const scaleFactor = 10;
    const layer = new Konva.Layer();
    stage.add(layer);
    // Funktion zum Zeichnen der XY-Achse
    function drawXYAchse(torX, torY, selectedWidth, selectedHeight, segmente) {
      //const { containerWidth, containerHeight } = getAvailableDimensions();
      // Abstand der Achsen vom Tor
      const abstand = 20;

      // Die Höhe der Gummilippe (43.5 mm) wird berücksichtigt
      const gummilippeHoehe = 43.5 / scaleFactor; // Skaliere auf die 1/10 Basis

      // X-Achse exakt an den Torbreitenkanten zeichnen
      const xLine = new Konva.Line({
        points: [
          torX, // X-Start direkt am linken Rand des Tores
          torY + selectedHeight / scaleFactor + abstand, // Unterhalb des Tores (X-Achse bleibt konstant)
          torX + selectedWidth / scaleFactor, // X-Ende direkt am rechten Rand des Tores
          torY + selectedHeight / scaleFactor + abstand, // Gleiche Y-Position unterhalb des Tores
        ],
        stroke: "black",
        strokeWidth: 2,
      });

      // Skalenmarkierung links bei 0
      const leftTick = new Konva.Line({
        points: [
          torX, // Links genau am Anfang der X-Achse
          torY + selectedHeight / scaleFactor + abstand, // Unten an der X-Achse
          torX, // Gleiche X-Position
          torY + selectedHeight / scaleFactor + abstand + 10, // Kleine Markierung nach unten
        ],
        stroke: "black",
        strokeWidth: 2,
      });

      // Beschriftung "0" für die linke Skalenmarkierung
      const leftLabel = new Konva.Text({
        x: torX - 5, // Position leicht links der Skalenmarkierung
        y: torY + selectedHeight / scaleFactor + abstand + 15, // Etwas unter der Markierung
        text: "0",
        fontSize: 12,
        fill: "black",
      });

      // Skalenmarkierung rechts bei der Torbreite
      const rightTick = new Konva.Line({
        points: [
          torX + selectedWidth / scaleFactor, // Rechts genau am Ende der X-Achse
          torY + selectedHeight / scaleFactor + abstand, // Unten an der X-Achse
          torX + selectedWidth / scaleFactor, // Gleiche X-Position
          torY + selectedHeight / scaleFactor + abstand + 10, // Kleine Markierung nach unten
        ],
        stroke: "black",
        strokeWidth: 2,
      });

      // Beschriftung mit der Torbreite für die rechte Skalenmarkierung
      const rightLabel = new Konva.Text({
        x: torX + selectedWidth / scaleFactor - 20, // Leicht rechts der Skalenmarkierung
        y: torY + selectedHeight / scaleFactor + abstand + 15, // Etwas unter der Markierung
        text: `${selectedWidth}`,
        fontSize: 12,
        fill: "black",
      });

      // Füge alle Elemente zur Layer hinzu
      layer.add(xLine);
      layer.add(leftTick);
      layer.add(leftLabel);
      layer.add(rightTick);
      layer.add(rightLabel);

      // Y-Achse exakt an den Torhöhenkanten zeichnen, beginnend über der Gummilippe
      const yLine = new Konva.Line({
        points: [
          torX - abstand, // Links vom Tor
          torY - gummilippeHoehe, // Start direkt über der Gummilippe
          torX - abstand, // Gleiche X-Position (konstante Linie)
          torY + selectedHeight / scaleFactor - gummilippeHoehe, // Ende direkt an der oberen Kante des Tores
        ],
        stroke: "black",
        strokeWidth: 2,
      });

      // Skalenmarkierung oben für die Höhe des Tores
      const topYTick = new Konva.Line({
        points: [
          torX - abstand, // Links von der Y-Achse
          torY - gummilippeHoehe, // Obere Kante des Tores
          torX - abstand - 10, // Kleine Markierung nach links
          torY - gummilippeHoehe, // Gleiche Y-Position
        ],
        stroke: "black",
        strokeWidth: 2,
      });

      // Beschriftung der Y-Achse oben mit der Torhöhe (ohne "mm")
      const topYLabel = new Konva.Text({
        x: torX - abstand - 50, // Links neben der Y-Achse
        y: torY - gummilippeHoehe - 15, // Leicht oberhalb der oberen Kante des Tores
        text: `${selectedHeight}`, // Gesamthöhe des Tores (ohne "mm")
        fontSize: 12,
        fill: "black",
      });

      // Skalenmarkierung unten für die Gummilippenhöhe
      const bottomYTick = new Konva.Line({
        points: [
          torX - abstand, // Links von der Y-Achse
          torY + selectedHeight / scaleFactor - gummilippeHoehe, // Untere Kante des Tores minus die Gummilippe
          torX - abstand - 10, // Kleine Markierung nach links
          torY + selectedHeight / scaleFactor - gummilippeHoehe, // Gleiche Y-Position
        ],
        stroke: "black",
        strokeWidth: 2,
      });

      // Beschriftung der Y-Achse unten mit der Gummilippenhöhe (um 43.5 verschoben)
      const bottomYLabel = new Konva.Text({
        x: torX - abstand - 50, // Links neben der Y-Achse
        y: torY + selectedHeight / scaleFactor - gummilippeHoehe - 5, // Direkt an der unteren Kante des Tores (über der Gummilippe)
        text: `43.5`, // Höhe der Gummilippe (ohne "mm")
        fontSize: 12,
        fill: "black",
      });

      // Füge die Y-Achse, Skalenmarkierungen und die Beschriftungen zur Layer hinzu
      layer.add(yLine);
      layer.add(topYTick);
      layer.add(topYLabel);
      layer.add(bottomYTick);
      layer.add(bottomYLabel);

      // Zeichne die Beschriftungen für jede Sektion entlang der Y-Achse
      let currentY = torY + selectedHeight / scaleFactor - gummilippeHoehe; // Beginne oben, über der Gummilippe
      segmente.forEach((segmentHeight, index) => {
        const scaledSegmentHeight = segmentHeight / scaleFactor; // Skaliere die Höhe
        currentY -= scaledSegmentHeight; // Verschiebe Y nach oben für jede Sektion

        // Beschriftung für die Höhe der Sektion (um 90° gedreht)
        const sectionLabel = new Konva.Text({
          x: torX - abstand - 40, // Position links neben der Y-Achse
          y: currentY + scaledSegmentHeight / 2, // In der Mitte der Sektion
          text: `${segmentHeight}`, // Höhe der Sektion (ohne "mm")
          fontSize: 12,
          fill: "black",
          rotation: -90, // Drehe den Text um 90° gegen den Uhrzeigersinn
        });

        // Füge die Sektion-Beschriftung zur Layer hinzu
        layer.add(sectionLabel);
      });

      // Zeichne das Layer
      layer.draw();
    }

    // Funktion zum Zeichnen des Tors
    function drawGate(config) {
      layer.destroyChildren(); // Entferne alle vorherigen Zeichnungen
      console.log("Frame: " + config.frame);
      // Werte aus den Dropdown-Listen
      //const selectedWidth = parseInt(widthSelect.value);
      //const selectedHeight = parseInt(heightSelect.value);
      //const selectedRalColor = colorSelect.value; // RAL-Wert aus dem Dropdown
      //const selectedColor = ralToHex[selectedRalColor]; // Hole die HEX-Farbe aus dem Mapping
      //const hasFrame = frameSelect.value === 'ja';
      const selectedWidth = parseInt(config.width || 3000);
      const selectedHeight = parseInt(config.height || 3000);
      const selectedRalColor = "RAL 9006"; // RAL-Wert aus dem Dropdown
      const selectedColor = config.color; // Hole die HEX-Farbe aus dem Mapping
      const hasFrame = config.frame;
      // Bestimme die Sektionen basierend auf der Höhe
      let segmente;
      switch (selectedHeight) {
        case 3000:
          segmente = [750, 750, 750, 750];
          break;
        case 3250:
          segmente = [750, 625, 625, 625, 625];
          break;
        case 3500:
          segmente = [750, 750, 750, 625, 625];
          break;
        case 3750:
          segmente = [750, 750, 750, 750, 750];
          break;
        case 4000:
          segmente = [750, 750, 625, 625, 625, 625];
          break;
        case 4250:
          segmente = [750, 750, 750, 750, 625, 625];
          break;
        case 4500:
          segmente = [750, 750, 750, 750, 750, 750];
          break;
        case 4750:
          segmente = [750, 750, 750, 625, 625, 625, 625];
          break;
        case 5000:
          segmente = [750, 750, 750, 750, 750, 625, 625];
          break;
        case 5250:
          segmente = [750, 750, 750, 750, 750, 750, 750];
          break;
        case 5500:
          segmente = [750, 750, 750, 750, 625, 625, 625, 625];
          break;
        case 5750:
          segmente = [750, 750, 750, 750, 750, 750, 625, 625];
          break;
        case 6000:
          segmente = [750, 750, 750, 750, 750, 750, 750, 750];
          break;
        default:
          segmente = [750, 750, 750, 750]; // Standardfall
      }

      // Berechne das Zentrum des Containers
      //const containerWidth = stage.width();
      //const containerHeight = stage.height();
      const { containerWidth, containerHeight } = getAvailableDimensions();
      // Berechne das Zentrum des Tors (basierend auf der Breite und Höhe des Tors)
      const torX = (containerWidth - selectedWidth / scaleFactor) / 2; // Zentrierte X-Position
      const torY = (containerHeight - selectedHeight / scaleFactor) / 2; // Zentrierte Y-Position

      // XY-Achse zeichnen und die Höhe der Sektionen hinzufügen
      drawXYAchse(torX, torY, selectedWidth, selectedHeight, segmente);

      // Zeichne die Gummilippe unten (43 mm in Schwarz)
      const gummilippeHoehe = 43.5 / scaleFactor; // Skaliere die Höhe (43 mm)
      const gummilippe = new Konva.Rect({
        x: torX, // Zentriere die Gummilippe unter dem Tor
        y: torY + selectedHeight / scaleFactor - gummilippeHoehe, // Positioniere die Gummilippe am unteren Rand des Tores
        width: selectedWidth / scaleFactor, // Breite der Gummilippe entspricht der Sektion
        height: gummilippeHoehe, // Höhe der Gummilippe
        fill: "black", // Gummilippe ist schwarz
      });

      layer.add(gummilippe);

      // Tor zeichnen (als Rechteck) und Sektionen einfügen
      let currentY = torY + selectedHeight / scaleFactor - gummilippeHoehe; // Beginne von unten, oberhalb der Gummilippe
      const frameIndex = segmente.length - 2; // Finde das zweite Element von oben
      let frameYPosition = null; // Variable zum Speichern der Y-Position des Rahmens
      let segmentWidth = selectedWidth / scaleFactor; // Skaliere die Breite der Sektionen

      segmente.forEach((segmentHeight, index) => {
        const scaledSegmentHeight = segmentHeight / scaleFactor; // Skaliere die Höhe
        const gateSegment = new Konva.Rect({
          x: torX,
          y: currentY - scaledSegmentHeight, // Zeichne das Segment von unten nach oben
          width: segmentWidth,
          height: scaledSegmentHeight,
          fill: selectedColor, // Verwende die HEX-Farbe aus dem RAL-Mapping
          stroke: "black", // Zeichne den Rand in Schwarz
          strokeWidth: 2, // Randstärke
        });

        layer.add(gateSegment);

        // Speichere die Y-Position des zweiten Elements von oben
        if (index === frameIndex) {
          frameYPosition = currentY - scaledSegmentHeight; // Speichere die Y-Position für den Rahmen
        }
        // Lamellen einfügen
        let lamellenAnzahl;
        if (segmentHeight === 625) {
          lamellenAnzahl = 4; // Vier Lamellen bei 625 mm Segmenten
        } else if (segmentHeight === 750) {
          lamellenAnzahl = 5; // Fünf Lamellen bei 750 mm Segmenten
        }

        if (lamellenAnzahl) {
          const lamellenHoehe = scaledSegmentHeight / lamellenAnzahl; // Höhe jeder Lamelle
          for (let i = 1; i < lamellenAnzahl; i++) {
            const lamellenY = currentY - lamellenHoehe * i;

            const lamelleLine = new Konva.Line({
              points: [
                torX, // Linie startet links vom Tor
                lamellenY, // Y-Position der Linie
                torX + selectedWidth / scaleFactor, // Linie endet rechts vom Tor
                lamellenY, // Gleiche Y-Position
              ],
              stroke: "black",
              strokeWidth: 1, // Breite der Linien für Lamellen
            });

            layer.add(lamelleLine);
          }
        }
        currentY -= scaledSegmentHeight; // Verschiebe Y für die nächste Sektion nach oben
      });

      // Verglasungsrahmen hinzufügen, wenn ausgewählt
      if (hasFrame == "Ja" && frameYPosition !== null) {
        const frameWidth = segmentWidth; // Der Rahmen hat dieselbe Breite wie die Sektion
        const frameHeight = segmente[frameIndex] / scaleFactor; // Höhe des Rahmens entspricht der Sektion

        // Rahmenstärke von 60 mm auf allen Seiten
        const rahmenStaerke = 60 / scaleFactor; // Skaliere die 60 mm für den Rahmen (links, rechts, oben und zwischen Fenstern)

        // Zeichne den Hauptrahmen (innerhalb der Sektion)
        const frame = new Konva.Rect({
          x: torX, // Zentrierte X-Position
          y: frameYPosition, // Y-Position des Rahmens
          width: frameWidth, // Die volle Breite der Sektion
          height: frameHeight, // Die Höhe des Rahmens entspricht der Sektion
          fill: "grey",
          stroke: "black",
          strokeWidth: 2, // Rand des Rahmens
        });

        layer.add(frame);

        // Anzahl der Fenster bestimmen basierend auf der Breite
        let fensterAnzahl;
        if (selectedWidth <= 3000) {
          fensterAnzahl = 2;
        } else if (selectedWidth >= 3250 && selectedWidth <= 4500) {
          fensterAnzahl = 3;
        } else if (selectedWidth >= 4750 && selectedWidth <= 5500) {
          fensterAnzahl = 4;
        } else if (selectedWidth >= 5750) {
          fensterAnzahl = 5;
        } else {
          fensterAnzahl = 2; // Standard 2 Fenster
        }

        // Berechne den Platz für die Fenster, mit einem Rahmen von 60 mm links, rechts und zwischen den Fenstern
        const totalInnerSpace =
          frameWidth - 2 * rahmenStaerke - (fensterAnzahl - 1) * rahmenStaerke; // Platz für Fenster ohne Rahmen
        const fensterBreite = totalInnerSpace / fensterAnzahl; // Breite jedes Fensters
        const fensterHoehe = frameHeight - 2 * rahmenStaerke; // Höhe der Fenster (mit 60 mm Abstand oben und unten)

        for (let i = 0; i < fensterAnzahl; i++) {
          // Fenster beginnen nach dem linken Rahmen und sind gleichmäßig verteilt mit einem 60 mm Abstand zwischen den Fenstern
          const fensterX =
            torX + rahmenStaerke + i * (fensterBreite + rahmenStaerke);

          // Zeichne das Fenster
          const fenster = new Konva.Rect({
            x: fensterX,
            y: frameYPosition + rahmenStaerke, // Beginne nach dem oberen Rahmen
            width: fensterBreite,
            height: fensterHoehe,
            fill: "#fff", // Fensterfarbe (weiß)
            // Keine Umrandung um die Fenster
          });

          layer.add(fenster);

          // Zentriere den Text "S2" im Fenster
          const fensterText = new Konva.Text({
            x: fensterX,
            y: frameYPosition + rahmenStaerke, // Y-Position des Fensters
            width: fensterBreite, // Text soll mittig im Fenster erscheinen
            height: fensterHoehe,
            text: "S2", // Der Text "S2"
            fontSize: 14, // Schriftgröße des Textes (wie angepasst)
            fontFamily: "Arial",
            fill: "black", // Textfarbe schwarz
            align: "center",
            verticalAlign: "middle",
          });

          layer.add(fensterText); // Füge den Text zum Layer hinzu
        }
      }

      // Zeichne das Layer
      layer.draw();
    }

    // Event Listener für Änderungen in den Dropdowns
    document.body.addEventListener(
      "PRODUCT_BUILDER_OPTION_ACTIVATE",
      function (event) {
        // Gib das Event in der Konsole aus, um sicherzustellen, dass die Daten korrekt sind
        console.log("PRODUCT_BUILDER_OPTION_ACTIVATE Event:", event);
        // Extrahiere die Kategorie (Breite, Höhe, etc.) und den Wert (z.B. 4250 mm)
        const category = event.detail.category;
        const option = event.detail.option;

        if (category && option) {
          const categoryTitle = category.title;
          const selectedValue = option.icon;
          const numericValue = parseInt(selectedValue); // Umwandlung von z.B. '4250 mm' in Zahl

          // Aktualisiere das gateConfig-Objekt basierend auf der Kategorie
          if (categoryTitle === "Breite") {
            gateConfig.width = numericValue;
          } else if (categoryTitle === "Höhe") {
            gateConfig.height = numericValue;
          } else if (categoryTitle === "Farbe") {
            gateConfig.color = event.detail.color; // Farbe (z.B. 'RAL 9006')
          } else if (categoryTitle === "Verglasungsrahmen") {
            gateConfig.frame = selectedValue; // Boolean für Rahmen
          }
          //Factor berechnen
          const cont = document.querySelector(".konvajs-content");
          const containerW = cont.clientWidth;
          const containerH = cont.clientWidth;
          console.log("W= " + containerW + " H= " + containerH);
          // Zeichne das Tor mit den aktuellen Werten aus dem gateConfig-Objekt
          drawGate(gateConfig);
        }
      }
    );

    //widthSelect.addEventListener('change', drawGate);
    //heightSelect.addEventListener('change', drawGate);
    //frameSelect.addEventListener('change', drawGate);
    //colorSelect.addEventListener('change', drawGate);

    // Initiales Zeichnen
    drawGate(gateConfig);

    observer.disconnect(); // Stoppe die Beobachtung, wenn das Element gefunden wurde
  }
});

// Ursprünglichen Observer starten, um die DOM-Änderungen zu überwachen
observer.observe(document.body, { childList: true, subtree: true });
